import { uiConfig as defaultUiConfig } from '../../../../../../../../../../../../common/conf/concepts';

const conceptSelectionTableUiConfig = {
    ...defaultUiConfig,
    withActions: ['view'],
    properties: {
        displayName: {
            name: 'OpenCds Concept',
            sortable: true,
            nullable: false,
            rowDisplay: true,
            accessorOverride: (v) => {
                console.log('v', v);
                return `${v?.openCdsConceptDTO?.displayName} (${v?.openCdsConceptDTO?.code})`;
            }
        }
    }
};

const conceptSelectionTableUiConfigReadOnly = {
    ...defaultUiConfig,
    properties: {
        displayName: {
            ...defaultUiConfig.properties.displayName,
            input: 'valueDisplay'
        },
        codeId: {
            ...defaultUiConfig.properties.codeId,
            input: 'valueDisplay'
        },
        code: {
            ...defaultUiConfig.properties.code,
            input: 'valueDisplay'
        },
        description: {
            ...defaultUiConfig.properties.description,
            input: 'valueDisplay'
        },
        auditId: {
            ...defaultUiConfig.properties.auditId,
            input: 'valueDisplay'
        }
    }
};

export default {
    uiConfigTable: conceptSelectionTableUiConfig,
    uiConfigReadOnly: conceptSelectionTableUiConfigReadOnly
};
